<template>
	<!-- 来源信息 -->
	<div class="Minister-top information">
		<div class="Minister-top-top Ministerbackground">
			<div class="Minister-top-left Minister-top-color">来源信息</div>
		</div>
		<div class="information_content">

			<div class="information_input"" >
				<div class="information_Title">
					来源URL
				</div>
				<div class="input_el input_span">
							<el-row v-for="(item, index) in blue_point" :key="index" style="margin-bottom: 10px">
								<el-col :span="22" style="position: relative;">
									<el-input
											placeholder="可记录采集来源、采购Url等。仅在ERP显示，不会同步到销售平台！"
											v-model="item.value"
											:disabled="system < 5 || isChakan"
											class="width85"
									>
									</el-input>
									<el-button
											style="background: rgb(224,224,224)"
											:disabled="system < 5 || isChakan"
										@click="handleURL(item.value)"
									>访问链接</el-button>
									<el-button
											type="danger"
											:disabled="system < 5 || isChakan"
											@click="deleteItem(item, index)"
											icon="el-icon-delete"
											v-if="index > 0"
									></el-button>
									<el-button
											type="primary"
											:disabled="system < 5 || isChakan"
											@click="addItem(item, index)"
											icon="el-icon-plus"
											v-if="index == 0"
									></el-button>
								</el-col>
							</el-row>
				</div>
			</div>
			<div>
				<div class="information_input" >
					<div class="information_Title">
						备注
					</div>
					<div class="input_el input_span">
						<div class="newipt">
							<el-input
									type="textarea"
									:disabled="system < 5 || isChakan"
									class="width85"
									v-model="remark"
									:autosize="{ minRows: 3, maxRows: 4}"
									show-word-limit
							></el-input>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {ajaxPost, Baseurl} from "../../../api/api/api";
	export default {
		name: 'laiyuanComp',
		data() {
			return {
				blue_point: [{}],
        remark:'',
			}
		},
    props: {
      isChakan: {
        type: Boolean,
        default:false,
      },
      system: {
      type: Number,
      default:5,
    },
      isEdit: {
        type: Boolean,
        default:false,
      }
    },
		methods: {
      initData(){
        this.remark = ''
        this.blue_point = [{
          value: ''
        }]
      },
			handleURL(url) {
				if (!url){
					this.$message('访问链接不能为空！')
					return
				}
				window.open(url)
			},
			// 删除链接
			deleteItem(item, index) {
				this.blue_point.splice(index, 1)
				this.$message({
					type: 'success',
					message: '删除成功!',
				})
			},
			// 添加链接
			addItem() {
				if (this.blue_point.length < 5) {
					const param = {
						value: '',
					}
					this.blue_point.push(param)
				} else {
					this.$message('此链接记录货源链接最多5条字段')
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	@import "../ozon.less";
</style>
